export default {"src":"/_next/static/media/1.352c9846.svg","height":171,"width":305,"blurWidth":0,"blurHeight":0};